// ============================================
// MOB — Mafia of Baptiste
// Custom scripts for Dawn theme injection
// ============================================

(function() {
  // Only run on MOB pages
  if (!document.querySelector('.mob-page')) return;

  // --- Force body dark ---
  document.body.classList.add('mob-page');

  // --- Custom Cursor ---
  const cursor = document.querySelector('.mob-cursor');
  if (cursor && window.innerWidth > 768) {
    document.addEventListener('mousemove', (e) => {
      cursor.style.left = e.clientX - 10 + 'px';
      cursor.style.top = e.clientY - 10 + 'px';
    });
    document.querySelectorAll('a, button, .mob-card, .mob-mosaic-cell, .mob-media-block, .mob-btn, .mob-service').forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('hovering'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('hovering'));
    });
  }

  // --- Floating Hearts ---
  const heartColors = ['#e63946', '#4895ef', '#55a630', '#ffd60a', '#7B2FBE', '#ff6b35'];
  const container = document.querySelector('.mob-hearts-bg');

  function spawnHeart() {
    if (!container) return;
    const heart = document.createElement('span');
    heart.className = 'mob-heart';
    heart.innerHTML = '\u2665';
    heart.style.left = Math.random() * 100 + 'vw';
    heart.style.color = heartColors[Math.floor(Math.random() * heartColors.length)];
    heart.style.fontSize = (Math.random() * 14 + 8) + 'px';
    heart.style.animationDuration = (Math.random() * 12 + 10) + 's';
    heart.style.animationDelay = (Math.random() * 5) + 's';
    container.appendChild(heart);
    setTimeout(() => { if (heart.parentNode) heart.remove(); }, 25000);
  }

  for (let i = 0; i < 20; i++) setTimeout(spawnHeart, Math.random() * 3000);
  setInterval(spawnHeart, 1800);

  // --- Scroll Reveal ---
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.mob-reveal, .mob-stagger').forEach(el => obs.observe(el));

  // --- Parallax hearts ---
  if (container) {
    window.addEventListener('scroll', () => {
      container.style.transform = 'translateY(' + (window.scrollY * 0.05) + 'px)';
    });
  }

})();
